import { trimEnd } from 'lodash-es';
import { normalizePath } from '../utils';
const settings = new Proxy({
    uid: '5b6eb06',
    routePrefix: '',
    apiUrl: '',
    JWT: '',
    salesSeasonId: NaN,
    configure: function (config) {
        Object.assign(this, config);
    },
}, {
    get(target, prop) {
        if (prop === 'JWT' && typeof target[prop] === 'function') {
            return target[prop]();
        }
        return target[prop];
    },
    set(target, prop, value) {
        // TODO: Do we need this validation? Probably, no. A Container App should take care of Module initialization.
        switch (prop) {
            case 'routePrefix':
                target[prop] = normalizePath(value);
                break;
            case 'apiUrl':
                target[prop] = trimEnd(value, '/?#');
                break;
            default:
                target[prop] = value;
        }
        return true;
    },
});
export { settings };
